import classNames from 'classnames'
import { ReactElement, useContext } from 'react'
import { SchedulingWizardContext } from './SchedulingWizard'

export function AppointmentTypeSelector(): ReactElement {
  const { appointmentTypes, apptType, back, setApptType, patientType } = useContext(SchedulingWizardContext)
  return (
    <div
      className={`flex flex-col gap-y-2 animate-duration-[400ms] ${back ? `animate-fade-right` : `animate-fade-left`}`}
    >
      <span className="text-sm font-medium leading-tight text-neutral-700">
        What type of appointment are you looking for?
      </span>
      {appointmentTypes.length > 0 ? (
        <div className="flex grow flex-col gap-y-1.5 overflow-y-auto">
          {appointmentTypes
            .filter((type) => !type.patientType || type.patientType === patientType)
            .map((type) => (
              <button
                key={type.id}
                className={classNames(
                  `rounded-lg px-4 py-2 text-left text-neutral-900 shadow-elevation-1 hover:bg-gray-100`,
                  {
                    'border-2 border-[#0067FD]': apptType === type,
                    border: apptType !== type,
                  },
                )}
                style={{
                  backgroundColor: apptType === type ? `rgba(0, 134, 255, 0.08)` : `#FFFFFF`,
                }}
                onClick={() => setApptType(type)}
              >
                <span className="text-sm font-medium leading-[17.5px]">{type.alias ?? type.displayName}</span>
              </button>
            ))}
        </div>
      ) : (
        <span className="text-left text-neutral-500">There are currently no appointment types available</span>
      )}
    </div>
  )
}
